/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_EyebrowInputs */

const en_directory_submit_eyebrow = /** @type {(inputs: Directory_Submit_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit to Seek AI`)
};

const zh_directory_submit_eyebrow = /** @type {(inputs: Directory_Submit_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交到 Seek AI`)
};

/**
* | output |
* | --- |
* | "Submit to Seek AI" |
*
* @param {Directory_Submit_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_eyebrow = /** @type {((inputs?: Directory_Submit_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_eyebrow(inputs)
	return zh_directory_submit_eyebrow(inputs)
});
export { directory_submit_eyebrow as "directory.submit.eyebrow" }